import {FC} from 'react'
import { useSelector } from "react-redux";
import { reduxProps } from "../../../../constants";
import { NavLink } from 'react-router-dom';
import {UiIcon} from '../../../../components/UiIcon'
import {DrawerComponent} from '../../../assets/ts/components'

const AsideUserMenu: FC = () => {
  const {staffInfo} = useSelector((state:reduxProps)=>state.authReducer);
  const {classroom} = useSelector((state:reduxProps)=>state.educationReducer);
  const name = `${staffInfo.name || ''} ${staffInfo.lastName || ''}`.trim() || 'Öğretmen'
  const initials = [staffInfo.name, staffInfo.lastName].filter(Boolean).map(value => value.charAt(0).toLocaleUpperCase('tr')).join('') || 'Ö'
  const content = (
    <>
      <span className='aside-user-avatar' aria-hidden='true'>{initials}</span>
      <div className='aside-user-copy'>
        <div className='aside-user-name' title={name}>{name}</div>
        <div className='aside-user-email' title={staffInfo.email}>{staffInfo.email}</div>
      </div>
    </>
  )

  if (classroom?.b2CClass) {
    return (
      <NavLink className='aside-user' to='/profile' end aria-label={`${name} profili`} onClick={() => DrawerComponent.getInstance('kt_aside')?.hide()}>
        {content}
        <UiIcon name='arrow' size={16}/>
      </NavLink>
    )
  }

  return <div className='aside-user'>{content}</div>
};

export {AsideUserMenu}
